import { MouseEventHandler } from 'react'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { IconButton, InputAdornment } from '@mui/material'

interface PasswordEndAdornmentProps {
  visible: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
}

export default function PasswordEndAdornment({
  visible,
  onClick,
}: PasswordEndAdornmentProps): JSX.Element {
  return (
    <InputAdornment position="end">
      <IconButton onClick={onClick} edge="end">
        {visible ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  )
}
